module.exports = __webpack_public_path__ + "img/5.738d2296.png";